import { Skeleton } from '@eliadmin/core/src/components/ui/skeleton';

const skeletonClassName = 'motion-reduce:animate-none';

export const RealtyCardSkeleton = () => {
  return (
    <div
      aria-hidden="true"
      className="flex min-h-[514px] w-full min-w-0 flex-col items-start justify-start gap-4 overflow-hidden rounded-[16px] bg-card p-4 xl:min-h-[232px] xl:flex-row xl:items-center xl:gap-8 xl:py-4 xl:pl-4 xl:pr-8"
      data-eli-component="realty-card-skeleton"
      data-testid="realty-card-skeleton"
    >
      <Skeleton
        className={`aspect-[326/257] max-h-[350px] w-full shrink-0 rounded-[16px] bg-border xl:aspect-auto xl:h-[200px] xl:w-[253.704px] xl:max-w-none ${skeletonClassName}`}
      />

      <div className="flex min-h-[139px] w-full min-w-0 flex-col items-start gap-4 xl:min-h-0 xl:flex-1">
        <div className="flex h-6 w-full min-w-0 items-start gap-1">
          <Skeleton className={`h-6 w-[54px] rounded-full bg-muted ${skeletonClassName}`} />
          <Skeleton className={`h-6 w-[48px] rounded-full bg-muted ${skeletonClassName}`} />
          <Skeleton className={`h-6 w-[58px] rounded-full bg-muted ${skeletonClassName}`} />
          <Skeleton className={`h-6 w-[74px] rounded-full bg-muted ${skeletonClassName}`} />
        </div>

        <div className="flex h-[43.2px] w-full flex-col gap-2 xl:h-[57.6px]">
          <Skeleton
            className={`h-[17.6px] w-[88%] rounded-md bg-muted xl:h-[24.8px] ${skeletonClassName}`}
          />
          <Skeleton
            className={`h-[17.6px] w-[62%] rounded-md bg-muted xl:h-[24.8px] ${skeletonClassName}`}
          />
        </div>

        <Skeleton className={`h-px w-14 shrink-0 rounded-none bg-border ${skeletonClassName}`} />
        <Skeleton
          className={`h-[22px] w-[116px] rounded-md bg-muted xl:h-[29px] xl:w-[148px] ${skeletonClassName}`}
        />
      </div>

      <Skeleton
        className={`h-[54px] w-full shrink-0 rounded-[16px] bg-primary/10 xl:w-[190px] ${skeletonClassName}`}
      />
    </div>
  );
};
